/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__Answer_0Inputs */

const en_help_center__account_n_technical__answer_0 = /** @type {(inputs: Help_Center__Account_N_Technical__Answer_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click "Forgot Password" on the login pop-up. Enter your email address, and we'll send you a password reset link. The link is valid for 24 hours. If you don't receive the email, check your spam folder or contact support.`)
};

/**
* | output |
* | --- |
* | "Click \"Forgot Password\" on the login pop-up. Enter your email address, and we'll send you a password reset link. The link is valid for 24 hours. If you don't..." |
*
* @param {Help_Center__Account_N_Technical__Answer_0Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__answer_0 = /** @type {((inputs?: Help_Center__Account_N_Technical__Answer_0Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__Answer_0Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__answer_0(inputs)
});